import * as Sentry from '@sentry/react';

import { FallbackComponent } from './components/fallback-component';

export const ErrorBoundary = ({ children }: { children: JSX.Element }) => {
  return <Sentry.ErrorBoundary fallback={FallbackComponent}>{children}</Sentry.ErrorBoundary>;
};
